import React, { useEffect, useState } from "react";
import { BouncingLoader } from '../../pure-components/Loader';

import { ErrorToast, SuccessToast, WarningToast } from '../../pure-components/CustomToast';
import { toast } from 'react-toastify';

import "./style.css";
import API from "../../services/api";
import Validator from "../../services/validator";
import axios from "axios";
import Helper from "../../services/helper";
import CookieManager from "../../services/CookieManager";
import FingerprintIcon from '@mui/icons-material/Fingerprint';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

function Login () {
    const validator = new Validator();
    const [userData, setUserData] = useState({
        email : "",
        password : "",
    })
    const [helperText, setHelperText] = useState({});
    const [isDisabled, setIsDisabled] = useState(true);
    const [signingIn, setSigningIn] = useState(false);
    
    const [paymentForm, setPaymentForm] = useState("");

    const params = new URLSearchParams(window.location.search);
    const status = params.get("status");

    const [showPassword, setShowPassword] = useState(false);
    // Toggle the visibility state
    const togglePasswordVisibility = () => {
      setShowPassword((prevState) => !prevState);
    };
    
    useEffect(() => {

      if(status){
        //signing out, while redirected after payment processing.
        Helper.signOut();
        
        status === "Success" ? 
        toast(({ closeToast }) => <SuccessToast message={"Subscribed successfully. Login to continue."}/>) : 
        toast(({ closeToast }) => <WarningToast message={"Subscription pending. Login to continue."}/>);
      }
    }, [])

    const handleInputChange = (e, key) => {
        let value = key === 'tos' ? e : e.target.value;
        if (key === 'email') {
          let res = validator.setValue(value, 'Email ').isNotEmpty().isEmail();
          let temp = {...helperText};
          temp[key] = res.mssg;
          setHelperText(temp);
        }
        if (key === 'password') {
          let res = validator.setValue(value, 'Password ').isNotEmpty().isString();
          let temp = {...helperText};
          temp[key] = res.mssg;
          setHelperText(temp);
        }
        if(helperText['email']?.length > 0 || helperText['password']?.length > 0)
          setIsDisabled(true);
        else
          setIsDisabled(false)
    
        let tempUserData = {...userData};
        tempUserData[key] = value;
        setUserData(tempUserData);
    };
    
    const handleSignIn = async() => {
        let counter = 0;
        let temp = {...helperText};
        let resEmail = new Validator(userData.email, 'Email ').isNotEmpty().isString();
        temp['email'] = resEmail.mssg;
        resEmail.status === false && counter++;
        let resValidator = new Validator(userData.password, 'Password ').isNotEmpty().isString();
        temp['password'] = resValidator.mssg;
        resValidator.status === false && counter++;
        setHelperText(temp);
        if(counter > 0){
          setIsDisabled(true);
          return;
        }
        // console.log({helperText});
        let payload = { email: userData.email?.toLowerCase(), password: Helper.encode(userData.password) };
        if (counter === 0) {
          setIsDisabled(true);
          setSigningIn(true);
        
          await API.logIn(payload).then(res => {
            setIsDisabled(false);
            // console.log('[USER LOGGED IN]',JSON.stringify(res));
            if (!res?.success) {
              toast(({ closeToast }) => <ErrorToast message={res.mssg}/>);
              setSigningIn(false)
            }else{
              const tempData = res.data ? res.data : {};

              localStorage.setItem("favs", JSON.stringify(tempData?.favorites));
              localStorage.setItem("history", JSON.stringify(tempData?.history));
              localStorage.setItem("resourceURL", JSON.stringify(tempData?.resourceURL));

              delete tempData?.favorites;
              delete tempData?.history;
              delete tempData?.resourceURL;
              CookieManager.setCookie("member-data", JSON.stringify(tempData?.memberData));
              delete tempData?.memberData;
              CookieManager.setCookie("user-data", JSON.stringify(tempData));

              let targetLocation = CookieManager.getCookie("target-location");
              if(targetLocation?.length){
                window.location = targetLocation;
                CookieManager.deleteCookie("target-location");
              }else if(res.data.userType === "SUPER_ADMIN" || res.data.userType === "ADMIN")
                window.location.pathname = "/admin";
              else
                window.location.pathname = "/";

            }
          })
          .catch((err) => {
            console.log("Sign In Error : ", err);    
            let msg = err?.msg || err?.mssg;
            if(err?.err?.indexOf("Not Activated") > -1)
              msg += err.err + ". Please contact your Admin."
            toast(({ closeToast }) => <ErrorToast message={msg}/>);
            setSigningIn(false);
            setIsDisabled(false);
          });
        }
    }

    const pay = async() => {
        try {
         
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}api/users/create-order/test_solo01@test.com/prod_aab97c7d-206c-484f-bdf4-a451cd5123fc`, {}).then(res => {
              console.log("form data response : ", res);
              return res;
            });
            // const response = await axios.post(`localhost:3001/ccavRequestHandler`, orderData).catch((err) => {
            //   console.log("Error : ", err)
            // });
            // document.body.innerHTML = response.data;  // Insert the form into the DOM to automatically submit to CCAvenue
            
            // setPaymentForm(response.data);
            // const formContainer = document.createElement('div');
            // formContainer.innerHTML = response.data;
            // document.body.appendChild(formContainer);
            
            // const form = document.getElementById('paymentForm');
            // form.submit();
            
            const options = {
              key: "rzp_live_SKRibCIyxM5i6t",
              subscription_id: response.data.id,

              name: "Your App",
              description: "Pro Plan",

              handler: function (resp) {
                console.log("Subscription Success", resp);
                console.log("Payment response data : ", response);
                const dataObj = {
                    rp_sub_id : response.data.id, 
                    rp_payment_id : resp?.razorpay_payment_id
                }
                axios.post(
                `${process.env.REACT_APP_BASE_URL}/api/users/update-subs/${Helper.encode(userData.email?.toLowerCase())}`, 
                dataObj)
                .then(resp => {
                  console.log("payment cnfrm response : ", resp);
                })
                .catch((err) => {
                    console.log("Payment response handling error  : ", err)
                });
              },

              theme: {
                color: "#ec4899",
              },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
          } catch (error) {
            console.error('Payment initiation failed:', error);
          }
    }

    // useEffect(()=> {
    //   console.log("useEffect paymentForm : ", paymentForm)
    //   // if(paymentForm?.length > 0){
    //   //   const form = document.createElement(paymentForm);
    //   //   form.submit();

    //   //   setPaymentForm("");
    //   // }
    // }, [paymentForm])
    const submitForm = () => {
        if (paymentForm) {
            // document.paymentForm?.submit();
          const formElement = document.getElementById('paymentForm');
          console.log("paymentForm Data : ", paymentForm, formElement);
          if (formElement) {
            formElement.submit();
          }
        }
      };
  return (
    <div className="w-full lg:px-20 flex flex-wrap canvas">

        <div className="w-full justify-center flex">
        {signingIn ?
            <div className='w-full'>
            <div className='w-full pt-20 pb-10'>
                <BouncingLoader />
                <span className='w-full flex justify-center text-green-500 profile-header'><b>Signing In, Please Wait...</b></span>
            </div>
            </div>
            :
            <div className="lg:w-1/2 sm:w-full flex flex-wrap mt-16 mb-10 rounded-2xl box" >
                <div className="w-full flex rounded-2xl">
                  <div className="w-full pl-12 my-2">
                    <div className="w-full py-4">
                        <span className="w-full flex plan-header">
                            Sign In
                        </span>
                    </div>
                    <div className="w-full pb-2">
                        <span className="w-full flex lic-title">
                            Email address
                        </span>
                        <span className="w-full flex">
                            <input
                                className={`w-full self-center input-field rounded-full py-2 mr-16 lic-text` }
                                id="email"
                                type="text"
                                placeholder="Email *"
                                value={userData.email}
                                onChange={(e) => handleInputChange(e, 'email')}
                                onBlur={(e) => handleInputChange(e, 'email')}     
                            />
                        </span>
                        <span className="w-full flex">
                            <p className="err-text pl-1">{helperText.email}</p>
                        </span>
                       
                    </div>

                    <div className="w-full pb-2">
                        <span className="w-full flex lic-title">
                            Password
                        </span>
                        <span className="w-full flex lic-text" style={{position: 'relative', display: 'flex', alignItems: 'center'}}>
                            <input
                                className={`w-full self-center input-field rounded-full py-2 mr-16` }
                                id="pwd"
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Password *"
                                value={userData.password}
                                onChange={(e) => handleInputChange(e, 'password')}
                                onBlur={(e) => handleInputChange(e, 'password')}
                            />
                            <button
                              type="button"
                              onClick={togglePasswordVisibility}
                              style={{position: 'absolute', left: '82%', border: "none"}}
                              title={showPassword ? 'Hide password' : 'Show password'}
                            >
                              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </button>
                        </span>
                       
                    </div>

                    
                    <div className="w-full pb-2">
                        <span className="w-full flex pr-14">
                            <button className={`py-1 px-3 text-center cursor-pointer border-0 ${isDisabled ? "btn-disabled" : "btn-pink"}`}
                              onClick={() => {handleSignIn()}}
                              disabled={isDisabled}
                            >           
                              <FingerprintIcon className='mr-1 mb-1' />
                              Sign In
                            </button>
                        </span>
                    </div>
                    <div className="w-full pb-2 flex">
                        <span className="lg:w-1/2 sm:w-full flex justify-start">
                            <p className="pr-4">Don't have an account? <a className="link-text cursor-pointer" href={process.env.REACT_APP_MKT_SITE_PRICING}><b>Sign Up</b> </a></p>
                        </span>
                        <span className="lg:w-1/2 sm:w-full flex justify-end mr-16">
                            <a className="lg:title-text sm:text-sm cursor-pointer" href={'/forgot-password'}><b>Forgot Password?</b> </a>
                        </span>
                    </div>
                    <div className="w-full pb-5">
                        <hr className="w-11/12 flex" />
                    </div>
                    
                    {/* <div className="w-full pb-2">
                        <span className="w-full flex pr-14">
                            <button className={`btn`} 
                            onClick={() => {pay()}}
                           > Pay </button>
                        </span>
                    </div> */}
                    {paymentForm && (
                        <div>
                        <div
                            id="paymentFormContainer"
                            dangerouslySetInnerHTML={{ __html: paymentForm }}
                            onLoad={submitForm()}
                        />
                        {/* Trigger form submission once it's rendered */}
                        
                        </div>
                    )}
                  </div>
                </div>
            </div>
        }
        </div>
        
    </div>
  );
}

export default Login;